var map = {
	"./ARTS-Cultural-spots-in-Toronto-KAISA KASEKAMP_THEVARSITY-web.jpg": 2824,
	"./ARTS-Get-Involved-Creatively-VARIOUS-ARTISTS.jpg": 4350,
	"./ARTS-Healthy-Tasty_Jishna-Sunkara THEVARSITY.jpg": 1706,
	"./BUSINESS-Internships research jobs-KAISA-Photo-for-article-selection.jpg": 8237,
	"./BUSINESS-internships-and-jobs-KAISA-PHOTO-FOR-ARTICLE-WEB.jpg": 9709,
	"./BUSINESS_Housing-Resources_VICKYHUANG THEVARSITY.jpg": 6130,
	"./BUSINESS_Networking-Tips-Illo_Evelyn-Bolton.jpg": 8731,
	"./COPY-Getting-Involved-with-the-Varsity.jpg": 1921,
	"./COVER-Background.png": 1565,
	"./COVER-Foreground.png": 798,
	"./CREDITS-WEB.jpg": 556,
	"./FEATURES-Places_of_worship_BiewBiewSakulwannadee_THEVARSITY copy.jpg": 1167,
	"./Filler-art.jpg": 7389,
	"./Get-involved-with-the-varsity-BANNER-HOME.jpg": 4756,
	"./NEWS-Important-people-KAISA-KASEKAMP-web.jpg": 1774,
	"./NEWS-Sexual-healthcare-NILIMA-PAUL-web.jpg": 7134,
	"./NEWS-news-stories-color.jpg": 9234,
	"./OPINION-Best_Libraries_VICKYHUANG_THEVARSITY copy.jpg": 2675,
	"./OPINION-First-date-spots-Toronto.jpg": 5671,
	"./OPINION-long-distance-relationships-KAISA KASEKAMP_THEVARSITY.jpg": 8851,
	"./SCIENCE-Mental_Physical_Health- ElenaOsipyan.jpg": 7139,
	"./SCIENCE-Socialising-tips-KAISA-photo2.jpg": 4049,
	"./SCIENCE-socializing-tips-KAISA KASEKAMP-photo1.jpg": 5660,
	"./SCIENCE-spending-time-in-nature-COLLAGE.jpg": 1144,
	"./SPORTS-Getting-active-in-school.jpg": 2907,
	"./SPORTS-getting-involved-sports-entertainment-KAISA KASEKAMP-photo2.jpg": 9248,
	"./SPORTS-getting-involved-sports-entertainment-KAISA KASEKAMP.jpg": 7551,
	"./U-of-T-Map.jpg": 4488,
	"./UOFT-MAP.jpg": 5124,
	"./mobile view/MOBILE-Cover-web-NO-TEXT-2.jpg": 9591,
	"./mobile view/MOBILE-Cover-web-NO-TEXT.jpg": 4610,
	"./opinion-course-load-VICKY HUANG_THEVARSITY.jpg": 3336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;